import { request } from '@umijs/max';
import { Constants } from '../../util/constants';

// ★ 管理APIの実体（Container Apps）
const API_BASE =
  'https://ca-manage-backend.braveplant-bd140fe7.japanwest.azurecontainerapps.io';

/** ログインユーザー情報取得 GET */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.Response>(`${API_BASE}/auth/currentUser`, {
    method: Constants.API.METHOD.GET,
    credentials: 'include', // ★必須
    ...(options || {}),
  });
}

/** ログイン POST */
export async function login(
  body: API.LoginInfo,
  options?: { [key: string]: any },
) {
  return request<API.Response>(`${API_BASE}/auth/login`, {
    method: Constants.API.METHOD.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    credentials: 'include', // ★必須
    ...(options || {}),
  });
}

/** ログアウト POST */
export async function outLogin(options?: { [key: string]: any }) {
  return request<API.Response>(`${API_BASE}/auth/logout`, {
    method: Constants.API.METHOD.POST,
    credentials: 'include', // ★必須
    ...(options || {}),
  });
}

/** トークンリフレッシュ POST */
export async function refresh(options?: { [key: string]: any }) {
  return request<API.Response>(`${API_BASE}/auth/refresh`, {
    method: Constants.API.METHOD.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // ★必須
    ...(options || {}),
  });
}
